import React from 'react'
import IDonor from '@interfaces/IDonor'
import DonorCardBase from './DonorCardBase'

interface SelectionDonorCardProps {
  donor: IDonor
  position: number
  selectedTreatment?: string
  onRemove: (id: string) => void
  isLast?: boolean
}

const SelectionDonorCard: React.FC<SelectionDonorCardProps> = ({
  donor,
  position,
  selectedTreatment,
  onRemove,
  isLast,
}) => {
  return (
    <DonorCardBase
      donor={donor}
      position={position}
      variant="selection"
      treatmentDisplayMode="all"
      selectedTreatment={selectedTreatment}
      isDraggable={true}
      isLast={isLast}
      showPhotoMatchColumn={false}
      onRemove={onRemove}
    />
  )
}

export default SelectionDonorCard
